import { lazy, Suspense } from "react";
import { LazyBoundary } from "./LazyBoundary.jsx";

// The stream players, loaded on first use. They pull in hls.js - about a quarter of the
// app's JavaScript - which the page does not need to first paint; a plain black box (what
// the players show before their first frame anyway) stands in while it loads, and a reload
// prompt if it fails to (see LazyBoundary).
const HLSPlayerImpl = lazy(() => import("./HLSPlayer.jsx"));
const HlsPreviewPlayerImpl = lazy(() => import("./HlsPreviewPlayer.jsx"));

export function HLSPlayer(props) {
  return (
    <LazyBoundary className="w-full h-full bg-black text-white">
      <Suspense fallback={<div className="w-full h-full bg-black" />}>
        <HLSPlayerImpl {...props} />
      </Suspense>
    </LazyBoundary>
  );
}

export function HlsPreviewPlayer(props) {
  return (
    <LazyBoundary className={`w-full h-full bg-black text-white ${props.className ?? ""}`}>
      <Suspense fallback={<div className={`w-full h-full bg-black ${props.className ?? ""}`} />}>
        <HlsPreviewPlayerImpl {...props} />
      </Suspense>
    </LazyBoundary>
  );
}
